import React, { useEffect, useState } from 'react'
import { SegmentedClauseParam } from '../../../../domain/types/ClauseParams';
import ParamTypeCombobox from '../../../../components/common/CustomCombobox/ParamTypeCombobox';
import { useTranslation } from '../../../../contexts/TranslationProvider';
import { BeneficialCompanyEntity, BeneficialMinorEntity, BeneficialPersonEntity } from '../../../../domain/entities';
import BeneficialFieldCombobox, { BeneficialField } from '../../../../components/common/CustomCombobox/BeneficialFieldCombobox';
import BeneficialType from '../../../../components/BeneficialType';


function AddparamForm({ params, setInsertNew, insertMention, handleClose, selected, search, existingParam = true, insideTable, insideList }) {
	const { t } = useTranslation();
	const [selectedType, setSelectedType] = useState<'Person' | 'Company' | 'Minor' | null>(null);
	const translationPath = "pages.contractTemplateParam.addParamForm";
	const beneficialTranslatioPath = "pages.editionContract.popups.benificial.inputs";
	const BeneficialListFields: BeneficialField[] = [
		{ field: 'description', label: t(beneficialTranslatioPath + ".company.description") },
		{ field: 'fullName', label: t(beneficialTranslatioPath + ".person.fullName") },
		{ field: 'signature', label: t(beneficialTranslatioPath + ".person.signature") },
	];
	const personBeneficialFields: BeneficialField[] = [
		{ field: 'description', label: t(beneficialTranslatioPath + ".company.description") },
		{ field: 'fullName', label: t(beneficialTranslatioPath + ".person.fullName") },
		{ field: 'signature', label: t(beneficialTranslatioPath + ".person.signature") },
		{ field: 'firstName', label: t(beneficialTranslatioPath + ".person.firstname") },
		{ field: 'lastName', label: t(beneficialTranslatioPath + ".person.lastname") },
		{ field: 'address', label: t(beneficialTranslatioPath + ".person.address") },
		{ field: 'cin', label: t(beneficialTranslatioPath + ".person.cin") },
		{ field: 'cinDeliverPlace', label: t(beneficialTranslatioPath + ".person.cinDeliverPlace") },
		{ field: 'cinDeliveryDate', label: t(beneficialTranslatioPath + ".person.cinDeliveryDate") },
		{ field: 'nationality', label: t(beneficialTranslatioPath + ".person.nationality") },
		{ field: 'dateOfBirth', label: t(beneficialTranslatioPath + ".person.dateOfBirth") },
		{ field: 'placeOfBirth', label: t(beneficialTranslatioPath + ".person.placeOfBirth") },
		{ field: 'maritalStatus', label: t(beneficialTranslatioPath + ".person.maritalStatus") },
		{ field: 'gender', label: t(beneficialTranslatioPath + ".person.gender") },
		{ field: 'jobTitle', label: t(beneficialTranslatioPath + ".person.jobTitle") },
		{ field: 'email', label: t(beneficialTranslatioPath + ".person.email") },
		{ field: 'passport', label: t(beneficialTranslatioPath + ".person.passport") },

		// { field: 'attorney.firstName', label: t(beneficialTranslatioPath + ".attorney.attorneyFirstName") },
		// { field: 'attorney.lastName', label: t(beneficialTranslatioPath + ".attorney.attorneyLastName") },
		// { field: 'attorney.fullName', label: t(beneficialTranslatioPath + ".attorney.attorneyFullName") },
		// { field: 'attorney.gender', label: t(beneficialTranslatioPath + ".attorney.attorneyGender") },
		// { field: 'attorney.cin', label: t(beneficialTranslatioPath + ".attorney.attorneyCin") },
		// { field: 'attorney.cinDeliveryDate', label: t(beneficialTranslatioPath + ".attorney.attorneyCinDeliveryDate") },
		// { field: 'attorney.cinDeliverPlace', label: t(beneficialTranslatioPath + ".attorney.attorneyCinDeliverPlace") },
		// { field: 'attorney.regionalFinancialOffice', label: t(beneficialTranslatioPath + ".attorney.regionalFinancialOffice") },
		// { field: 'attorney.powerOfAttorneyDate', label: t(beneficialTranslatioPath + ".attorney.powerOfAttorneyDate") },
		// { field: 'attorney.powerOfAttorneyReceitNumber', label: t(beneficialTranslatioPath + ".attorney.powerOfAttorneyReceitNumber") },
		// { field: 'attorney.powerOfAttorneyRegistrationNumber', label: t(beneficialTranslatioPath + ".attorney.powerOfAttorneyRegistrationNumber") },

		// { field: 'spouse.firstName', label: t(beneficialTranslatioPath + ".joint.spouseFirstName") },
		// { field: 'spouse.lastName', label: t(beneficialTranslatioPath + ".joint.spouseLastName") },
		// { field: 'spouse.fullName', label: t(beneficialTranslatioPath + ".joint.spouseFullName") },
		// { field: 'spouse.gender', label: t(beneficialTranslatioPath + ".joint.spouseGender") },
		// { field: 'spouse.cin', label: t(beneficialTranslatioPath + ".joint.spouseCin") },
		// { field: 'spouse.cinDeliveryDate', label: t(beneficialTranslatioPath + ".joint.spouseCinDeliveryDate") },
		// { field: 'spouse.cinDeliverPlace', label: t(beneficialTranslatioPath + ".joint.spouseCinDeliverPlace") },

		// { field: 'spouseAttorney.firstName', label: t(beneficialTranslatioPath + ".attorney.attorneyFirstName") },
		// { field: 'spouseAttorney.lastName', label: t(beneficialTranslatioPath + ".attorney.attorneyLastName") },
		// { field: 'spouseAttorney.fullName', label: t(beneficialTranslatioPath + ".attorney.attorneyFullName") },
		// { field: 'spouseAttorney.gender', label: t(beneficialTranslatioPath + ".attorney.attorneyGender") },
		// { field: 'spouseAttorney.cin', label: t(beneficialTranslatioPath + ".attorney.attorneyCin") },
		// { field: 'spouseAttorney.cinDeliveryDate', label: t(beneficialTranslatioPath + ".attorney.attorneyCinDeliveryDate") },
		// { field: 'spouseAttorney.cinDeliverPlace', label: t(beneficialTranslatioPath + ".attorney.attorneyCinDeliverPlace") },
		// { field: 'spouseAttorney.regionalFinancialOffice', label: t(beneficialTranslatioPath + ".attorney.regionalFinancialOffice") },
		// { field: 'spouseAttorney.powerOfAttorneyDate', label: t(beneficialTranslatioPath + ".attorney.powerOfAttorneyDate") },
		// { field: 'spouseAttorney.powerOfAttorneyReceitNumber', label: t(beneficialTranslatioPath + ".attorney.powerOfAttorneyReceitNumber") },
		// { field: 'spouseAttorney.powerOfAttorneyRegistrationNumber', label: t(beneficialTranslatioPath + ".attorney.powerOfAttorneyRegistrationNumber") },
	];

	const companyBeneficialFields: BeneficialField[] = [
		{ field: 'description', label: t(beneficialTranslatioPath + ".company.description") },
		{ field: 'fullName', label: t(beneficialTranslatioPath + ".person.fullName") },
		{ field: 'signature', label: t(beneficialTranslatioPath + ".person.signature") },
		{ field: 'socialCapital', label: t(beneficialTranslatioPath + ".company.socialCapital") },
		{ field: 'legalForm', label: t(beneficialTranslatioPath + ".company.legalForm") },
		{ field: 'companyName', label: t(beneficialTranslatioPath + ".company.companyName") },
		{ field: 'registrationNumber', label: t(beneficialTranslatioPath + ".company.registrationNumber") },
		{ field: 'socialCapitalCurrency', label: t(beneficialTranslatioPath + ".company.socialCapitalCurrency") },
		{ field: 'postalAddress', label: t(beneficialTranslatioPath + ".company.postalAddress") },
		{ field: 'specialization', label: t(beneficialTranslatioPath + ".company.specialization") },
		{ field: 'firstName', label: t(beneficialTranslatioPath + ".company.firstName") },
		{ field: 'lastName', label: t(beneficialTranslatioPath + ".company.lastName") },
		{ field: 'gender', label: t(beneficialTranslatioPath + ".person.gender") },
		{ field: 'email', label: t(beneficialTranslatioPath + ".person.email") },
		{ field: 'cin', label: t(beneficialTranslatioPath + ".person.cin") },
		{ field: 'cinDeliverPlace', label: t(beneficialTranslatioPath + ".person.cinDeliverPlace") },
		{ field: 'cinDeliveryDate', label: t(beneficialTranslatioPath + ".person.cinDeliveryDate") },
		{ field: 'passport', label: t(beneficialTranslatioPath + ".person.passport") },
		{ field: 'nationality', label: t(beneficialTranslatioPath + ".company.nationality") }
	];

	const minorBeneficialFields: BeneficialField[] = [
		{ field: 'description', label: t(beneficialTranslatioPath + ".company.description") },
		{ field: 'fullName', label: t(beneficialTranslatioPath + ".person.fullName") },
		{ field: 'signature', label: t(beneficialTranslatioPath + ".person.signature") },
		{ field: 'minorFirstName', label: t(beneficialTranslatioPath + ".minor.minorFirstName") },
		{ field: 'minorLastName', label: t(beneficialTranslatioPath + ".minor.minorLastName") },
		{ field: 'minorFullName', label: t(beneficialTranslatioPath + ".minor.minorFullName") },
		{ field: 'minorDateOfBirth', label: t(beneficialTranslatioPath + ".minor.minorDateOfBirth") },
		{ field: 'minorPlaceOfBirth', label: t(beneficialTranslatioPath + ".minor.minorPlaceOfBirth") },
		{ field: 'minorNationality', label: t(beneficialTranslatioPath + ".minor.minorNationality") },
		{ field: 'minorGender', label: t(beneficialTranslatioPath + ".minor.minorGender") },
		{ field: 'minorOrderNumber', label: t(beneficialTranslatioPath + ".minor.minorOrderNumber") },
		{ field: 'minorOrderDate', label: t(beneficialTranslatioPath + ".minor.minorOrderDate") },
		{ field: 'minorOrderCourt', label: t(beneficialTranslatioPath + ".minor.minorOrderCourt") },
		{ field: 'firstName', label: t(beneficialTranslatioPath + ".minor.firstName") },
		{ field: 'lastName', label: t(beneficialTranslatioPath + ".minor.lastName") },
		{ field: 'gender', label: t(beneficialTranslatioPath + ".minor.gender") },
		{ field: 'cin', label: t(beneficialTranslatioPath + ".minor.cin") },
		{ field: 'cinDeliverPlace', label: t(beneficialTranslatioPath + ".minor.cinDeliverPlace") },
		{ field: 'cinDeliveryDate', label: t(beneficialTranslatioPath + ".minor.cinDeliveryDate") },
		{ field: 'placeOfBirth', label: t(beneficialTranslatioPath + ".minor.placeOfBirth") },
		{ field: 'dateOfBirth', label: t(beneficialTranslatioPath + ".minor.dateOfBirth") },
	];

	const [paramType, setParamType] = useState<SegmentedClauseParam['type'] | null>(selected?.type || null);
	const [paramName, setParamName] = useState<string | null>(selected?.name || search || "");
	const [paramLabel, setParamLabel] = useState<string | null>(selected?.label || "");
	const [paramField, setParamField] = useState<keyof BeneficialPersonEntity | keyof BeneficialCompanyEntity | keyof BeneficialMinorEntity | null>(selected?.args?.field || null);
	const [paramFieldOptions, setParamFieldOptions] = useState<BeneficialField[]>(personBeneficialFields);
	const [errors, setErrors] = useState([]);
	const [availableTypes, setAvailableTypes] = useState<string[]>([]);

	useEffect(() => {
		const allTypes = ["date", "number", "string", "enum", "boolean", "list", "file", "beneficial", "beneficial[]", "table", "property", "static-table", "index"];
		if (insideTable || insideList) {
			setAvailableTypes(allTypes.filter(type => (type !== "static-table" && type !== "table")));
		} else {
			setAvailableTypes(allTypes);
		}
	}, [insideTable]);

	const onConfirm = () => {
		if (errors.length > 0 || !paramType || !paramName || !paramLabel || ((paramType === "beneficial" || paramType === "beneficial[]") && !paramField)) {
			return
		}
		let param: SegmentedClauseParam
		const defaultParam = {
			name: paramName, label: paramLabel,
			definition: 0
		}
		switch (paramType) {
			case 'static-table':
				param = {
					...defaultParam, type: paramType,
					args: { cells: [],
						style: {}
					 }
				}
				break;
			case 'enum':
				param = {
					...defaultParam, type: paramType,
					args: [],
				}
				break;
			case 'list':
				param = {
					name: paramName,
					label: paramLabel,
					type: paramType,
					args: [],
				}
				break;
			case 'boolean':
				param = {
					...defaultParam, type: paramType,
					args: {
						textIfTrue: [],
						textIfFalse: []
					}
				}
				break;
			case 'beneficial':
				param = {
					name: paramName,
					label: paramLabel,
					type: paramType,
					args: {
						beneficialTypes: [selectedType ? selectedType : "Person"],
					}
				}
				break;
			case 'beneficial[]':
				param = {
					...defaultParam,
					name: paramName,
					label: paramLabel,
					type: paramType,
					args: {
						beneficialTypes: ["Company", "Minor", "Person"],
					}
				}
				break;
			case 'table':
				param = {
					name: paramName,
					label: paramLabel,
					type: paramType,
					transposed: false,
					args: []
				}
				break;
			case 'property':
				param = {
					name: paramName,
					label: paramLabel,
					type: paramType,
					args: {
						tag: "",
						parentParam: "",
					}
				}
				break;
			case 'index':
				param = {
					name: paramName,
					label: paramLabel,
					type: paramType,
					args: { start: 0, step: 1 }
				}
				break;
			default:
				param = { type: paramType, name: paramName, label: paramLabel }
				break;
		}
		if (selected) {
			param = {
				...param,
				formula: selected.formula,
				constraints: selected.constraints,
			}
		}
		insertMention(param, paramField)
		setInsertNew(false)
		setParamType(null)
		setParamName("")
		setSelectedType(null)
		setParamLabel("")
		setParamField(null)
		handleClose()
	}

	const onCancel = () => {
		setInsertNew(false)
	}
	const beneficialFieldMap = {
		Person: personBeneficialFields,
		Company: companyBeneficialFields,
		Minor: minorBeneficialFields,
	};

	useEffect(() => {
		if (paramType === "beneficial") {
			const beneficialType = selectedType || selected?.args?.beneficialTypes?.[0];

			if (beneficialType && beneficialFieldMap[beneficialType]) {
				setParamFieldOptions(beneficialFieldMap[beneficialType]);
			}
		}
		if (paramType == "beneficial[]") {
			setParamFieldOptions(BeneficialListFields);
		}
	}, [paramType, selected, selectedType]);
	useEffect(() => {
		if (selected && selected.name) {
			console.log(selected)
			const existingParam = params.find(param => param.name === selected.name);
			if (existingParam && existingParam.name !== selected.name) {
				setErrors(prev => [...prev, { where: "name", why: ".errors.nameExists" }]);
			} else {
				if (!/^[a-z_][a-z0-9_]*$/i.test(selected.name)) {
					setErrors(prev => [...prev, { where: "name", why: ".errors.nameWrong" }]);
				}
			}
			return;
		}
		const existingParam1 = params.find(param => param.name === search);
		if (existingParam1) {
			setErrors(prev => [...prev, { where: "name", why: ".errors.nameExists" }]);
		} else {
			if (!/^[a-z_][a-z0-9_]*$/i.test(search)) {
				setErrors(prev => [...prev, { where: "name", why: ".errors.nameWrong" }]);
			}
		}
	}, [selected, search])

	const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setErrors(prev => prev.filter(err => err.where !== "name"));
		setParamName(e.target.value);
		if (!/^[a-z_][a-z0-9_]*$/i.test(e.target.value)) {
			setErrors(prev => [...prev, { where: "name", why: ".errors.nameWrong" }]);
		}
		const existingParam = params.find(param => param.name === e.target.value);
		if (!existingParam)
			return
		setErrors(prev => [...prev, { where: "name", why: ".errors.nameExists" }]);
	}

	const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setErrors(prev => prev.filter(err => err.where !== "label"));
		setParamLabel(e.target.value);
		if (!e.target.value) {
			setErrors(prev => [...prev, { where: "label", why: ".errors.labelMissing" }]);
		}
	}

	const handleTypeChange = (value) => {
		setErrors(prev => prev.filter(err => err.where !== "type"));
		setParamType(value);
		if (!value) {
			setErrors(prev => [...prev, { where: "type", why: ".errors.typeMissing" }]);
		}
	}

	const handleFieldChange = (value: keyof BeneficialPersonEntity | keyof BeneficialCompanyEntity | keyof BeneficialMinorEntity) => {
		if (value && (paramType === "beneficial" || paramType == "beneficial[]")) {
			setErrors(prev => prev.filter(err => err.where !== "field"));
		}
		setParamField(value);
		if (!value && (paramType === "beneficial" || paramType == "beneficial[]")) {
			setErrors(prev => [...prev, { where: "field", why: ".errors.fieldMissing" }]);
		}
	}
	return (
		<div
			className="dialog-container"
			style={{
				width: "100%",
				border: "none"
			}}>
			<div className="dialog-input-container">
				<div className="dialog-input-label">
					{t(translationPath + ".type")}
				</div>
				<ParamTypeCombobox
					options={availableTypes}
					value={paramType}
					onChange={handleTypeChange}
					disabled={selected}
				/>
				{
					errors.map(err => {
						if (err.where === "type") {
							return <div className="error-message-dialog">{t(translationPath + err.why)}</div>
						}
					})
				}
			</div>
			{(paramType == "beneficial") && (
				<div className="dialog-input-container">
					<div className="dialog-input-label">
						{t(translationPath + ".typeBeneficial")}
					</div>
					<BeneficialType
						selected={selected}
						disabled={selected}
						setSelectedType={setSelectedType}
					/>
				</div>)}

			<div className="dialog-input-container">
				<div className="dialog-input-label">
					{t(translationPath + ".name")}
				</div>
				<input disabled={selected} className="dialog-input" type="text" value={paramName} onChange={(e) => handleNameChange(e)} />
				{
					errors.map((err, idx) => {
						if (err.where === "name") {
							return <div key={idx} className="error-message-dialog">{t(translationPath + err.why)}</div>
						}
					})
				}
			</div>

			<div className="dialog-input-container">
				<div className="dialog-input-label">
					{t(translationPath + ".label")}
				</div>
				<input disabled={!existingParam ? false : selected} className="dialog-input" type="text" value={paramLabel} onChange={(e) => handleLabelChange(e)} />
				{
					errors.map((err, idx) => {
						if (err.where === "label") {
							return <div key={idx} className="error-message-dialog">{t(translationPath + err.why)}</div>
						}
					})
				}
			</div>

			{(paramType == "beneficial" || paramType == "beneficial[]") ? <div className="dialog-input-container">
				<div className="dialog-input-label">
					{t(translationPath + ".field")}
				</div>
				<BeneficialFieldCombobox
					options={paramFieldOptions}
					value={paramField}
					onChange={handleFieldChange}
				/>
				{
					errors.map((err, idx) => {
						if (err.where === "filed") {
							return <div key={idx} className="error-message-dialog">{t(translationPath + err.why)}</div>
						}
					})
				}
			</div>
				:
				<></>
			}
			<div className="dialog-buttons">
				<button className="dialog-button" onClick={onCancel}>
					{t(translationPath + ".cancel")}
				</button>
				<button
					className={`dialog-button ${errors.length > 0 || !paramType || !paramName || !paramLabel || ((paramType == "beneficial" || paramType == "beneficial[]") && !paramField) ? "dialog-button-disabled" : ""}`}
					onClick={onConfirm}>
					{t(translationPath + ".confirm")}
				</button>
			</div>

		</div>
	);
}

export default AddparamForm